import React, {useState, useEffect} from 'react';
import { MasterDataGrid } from "@/components/";
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import BeneficiariesError from '../beneficiaries-error';
import styles from './index.module.scss';

export interface IDisaggregationProps{    
    dataColumns: any;
    columns: any;
	status: any;
	screen: any;
    tableAlert: string;
    saveTable(instance: any): void;
    data: any;
    refresh: boolean;
}

const Disaggregation: React.FC<IDisaggregationProps> = ({dataColumns, columns, data, status, screen, tableAlert, refresh, saveTable} : IDisaggregationProps) => {
    const [auxData, setAuxData] = useState(null);

	const view: IFollowupSubproject = {
        state: {
			dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    useEffect(() => {
        if((tableAlert === `beneficiaries-totals-other-table` || !tableAlert || tableAlert === 'All' || tableAlert?.includes('expected-result-beneficiaries')) && data?.dissagregateData?.data && columns?.disaggregation) {

			let asd = getAuxData()
            setAuxData(asd)
        }
    }, [data?.dissagregateData?.data, tableAlert, columns?.disaggregation, status?.CodigoDimension, refresh, data?.dissagregateData?.data?.[0]?.descriptionValue]); 

    const changeStyles = (parentGrid: any) => {
        if(parentGrid !== undefined){
			const row = parentGrid.getRowElement(parentGrid.getVisibleRows().length - 3);
			if(row !== undefined){                                
				row[0].childNodes.forEach((child:any) => {  
					child.classList.add(styles.readOnly);
				});
			}
		}
    }

	const checkDisaggregation = () => {
        let disTable: any = presenter.getDataFromTable('beneficiaries-totals-other-table')
		return presenter.checkDisaggregation(disTable, status?.CodigoDimension)
    }

    const getAuxData = () => {
		return (
            <>
                <BeneficiariesError 
                    followupLabels={presenter.followupLabels}
                    tableAlert={tableAlert}
                    gridId={`beneficiaries-totals-other-table`} 
                    calculatedReqFields={(instance: any) => presenter.checkReqFields(instance, status)} 
                    calculatedDisagg={() => checkDisaggregation()} 
                    changeStyles={changeStyles}
                />
                <MasterDataGrid 
                    id={`beneficiaries-totals-other-table`}
                    dataSource={data?.dissagregateData?.data}
                    columns={columns?.disaggregation}
                    allowCode={screen}
                    gridTitle={presenter.followupLabels.get("beneficiariesByGenderTitle")}
                    gridHelpId={'tooltip-bygender'}
                    gridHelpText={presenter.followupLabels.get("helpBeneficiariesByGender")}
                    saveTable={saveTable}
                    gridProps={{
                        showColumnHeaders: false,
                        editing:{ mode:"batch", allowUpdating:true, allowAdding: false, allowDeleting: false},
                        rowAlternationEnabled:false,
                        showBorders: true,
                        showColumnLines: true,
                        width: 500,
                    }}
                />
            </>
        )
    }

    return (
		<> 
            {auxData && auxData}
        </>
	)
}

export default Disaggregation;